export default __webpack_public_path__ + "static/media/league-of-legends.5ee3cc23.png";